var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.11 26l-.36-.34.26-.39a9.1 9.1 0 001.56-5.49 9.93 9.93 0 00-10.13-9.68 9.86 9.86 0 100 19.72 9.59 9.59 0 005.33-1.49l.38-.24.32.32a6.07 6.07 0 004.31 1.41h.72v-1.91a1.13 1.13 0 00-.86-1.11 3.38 3.38 0 01-1.53-.8zM22 25.89a5.18 5.18 0 01-2.58.59 6 6 0 01-5.39-3.73l-.23-.55.56-.2a5.7 5.7 0 012-.35c2.79 0 4.41 1.68 5.84 3.4l.44.52zM24.82 23l-.4.7-.52-.63c-1.22-1.5-3.76-4-7-4a6.13 6.13 0 00-2.63.65l-.94.39.18-1c.57-3.42 2.87-5.54 5.95-5.54a6 6 0 016.12 6.22 6.42 6.42 0 01-.76 3.21z"
  })));
}
export default SvgQuiz;